module.exports = __webpack_public_path__ + "static/img/zhengshu5.b2d1945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengshu5.png
// module id = 4wSn
// module chunks = 1